module.exports = __webpack_public_path__ + "static/media/saleh.05ac427a.jpeg";